import magnific, { type MagnificOptions, MagnificType } from "@client/lib/jquery/magnific";
import { makeWith, makeWrap } from "./factory";

export const GalleryMagnificOptions: MagnificOptions = { type: MagnificType.Gallery };
export const IFrameMagnificOptions: MagnificOptions = { type: MagnificType.IFrame };
export const ImageMagnificOptions: MagnificOptions = { type: MagnificType.Image };
export const InlineMagnificOptions: MagnificOptions = { type: MagnificType.Inline };
export const NoneMagnificOptions: MagnificOptions = { type: MagnificType.None };

export interface MagnificProps {
  magnificOptions: MagnificOptions;
}

export const withMagnific = makeWith<MagnificProps>(
  (element: HTMLElement, props: MagnificProps) => magnific(element, props.magnificOptions),
  "magnificOptions"
);

const magnificTag = makeWrap<MagnificProps>(withMagnific);
export default magnificTag;
